@switch (type) {
  @case ('main') {
    <!-- CTA Final -->
    <section class="bg-[#002132] py-16 md:py-20 px-6 md:px-14" id="cta">
      <div class="max-w-[1300px] mx-auto">
        <div class="flex flex-col md:flex-row items-center justify-between gap-10 md:gap-16">
          <!-- Texto izquierdo -->
          <div class="flex-1 min-w-0" appScrollReveal="0s">
            <h2 class="font-montserrat text-2xl md:text-3xl font-bold text-white mb-4 leading-tight">
              ¿Quieres una copropiedad más transparente, ordenada y fácil de administrar?
            </h2>
            <p class="font-roboto text-base text-white/70 leading-relaxed">
              Agenda una presentación y te mostramos cómo CONVIVIA puede ayudarte a mejorar la comunicación, el recaudo,
              las asambleas y el control de activos de tu comunidad.
            </p>
          </div>

          <!-- CTAs derechos -->
          <div class="flex flex-col items-center md:items-end gap-4 shrink-0" appScrollReveal="0.2s">
            <button
              type="button"
              (click)="onOpenDemo()"
              class="bg-[#2563eb] text-white px-8 py-3.5 rounded-md font-roboto text-base font-semibold border-none cursor-pointer transition-all duration-200 ease-out hover:bg-[#1e40af] hover:-translate-y-[2px] hover:shadow-[0_8px_25px_rgba(37,99,235,0.35)] whitespace-nowrap"
              aria-label="Agendar demo para mi copropiedad">
              Agendar demo para mi copropiedad
            </button>
            <button
              type="button"
              (click)="onOpenDemo()"
              (keyup.enter)="onOpenDemo()"
              class="bg-transparent text-white/80 font-roboto text-sm font-medium border-none cursor-pointer hover:text-white transition-colors duration-150 underline underline-offset-4"
              aria-label="Solicitar diagnóstico gratuito">
              Solicitar diagnóstico gratuito
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="bg-[#001320] text-white pt-16 pb-8 px-6 md:px-14">
      <div class="max-w-[1300px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
        <!-- Columna 1: Marca -->
        <div class="lg:pr-6">
          <div class="flex items-center gap-3 mb-4">
            <app-convivia-logo size="28px" color="var(--p-green-500)"></app-convivia-logo>
            <span class="font-montserrat text-xl font-bold text-[var(--p-green-500)]">Convivia</span>
          </div>
          <p class="font-roboto text-white/55 text-sm leading-relaxed">
            Software y gestión para copropiedades más transparentes, organizadas y eficientes.
          </p>
        </div>

        <!-- Columna 2: Producto -->
        <div>
          <h4 class="font-roboto text-xs font-bold tracking-[1px] text-white/40 uppercase mb-4">Producto</h4>
          <ul class="flex flex-col gap-3">
            <li
              ><a
                href="#problems"
                class="text-white/60 no-underline font-roboto text-sm transition-colors duration-200 hover:text-white"
                >Problemas que resolvemos</a
              ></li
            >
            <li
              ><a
                href="#benefits"
                class="text-white/60 no-underline font-roboto text-sm transition-colors duration-200 hover:text-white"
                >Solución</a
              >
            </li>
            <li
              ><a
                href="#differential"
                class="text-white/60 no-underline font-roboto text-sm transition-colors duration-200 hover:text-white"
                >Diferenciales</a
              >
            </li>
            <li
              ><a
                href="#steps"
                class="text-white/60 no-underline font-roboto text-sm transition-colors duration-200 hover:text-white"
                >Cómo funciona</a
              ></li
            >
          </ul>
        </div>

        <!-- Columna 3: Contacto -->
        <div>
          <h4 class="font-roboto text-xs font-bold tracking-[1px] text-white/40 uppercase mb-4">Contacto</h4>
          <ul class="flex flex-col gap-3">
            <li>
              <button
                type="button"
                (click)="onOpenDemo()"
                (keydown.enter)="onOpenDemo()"
                class="flex items-center gap-2 text-white/60 bg-transparent border-none p-0 cursor-pointer font-roboto text-sm transition-colors duration-200 hover:text-white">
                <i class="pi pi-calendar text-xs"></i> Agendar demo
              </button>
            </li>
            <li
              ><a
                href="https://wa.me/573218474629"
                target="_blank"
                rel="noopener"
                class="flex items-center gap-2 text-white/60 no-underline font-roboto text-sm transition-colors duration-200 hover:text-white"
                ><i class="pi pi-whatsapp text-xs"></i> WhatsApp</a
              ></li
            >
            <li
              ><a
                href="mailto:comercial@convivia.com.co"
                class="flex items-center gap-2 text-white/60 no-underline font-roboto text-sm transition-colors duration-200 hover:text-white"
                ><i class="pi pi-envelope text-xs"></i> Email</a
              ></li
            >
          </ul>
        </div>

        <!-- Columna 4: Datos de contacto -->
        <div>
          <h4 class="font-roboto text-xs font-bold tracking-[1px] text-white/40 uppercase mb-4">Información</h4>
          <ul class="flex flex-col gap-3">
            <li class="flex items-start gap-2 text-white/60 font-roboto text-sm">
              <i class="pi pi-envelope text-xs mt-0.5 shrink-0"></i>
              <span>comercial&#64;convivia.com.co</span>
            </li>
            <li class="flex items-start gap-2 text-white/60 font-roboto text-sm">
              <i class="pi pi-phone text-xs mt-0.5 shrink-0"></i>
              <span>+57 321 847 4629</span>
            </li>
            <li class="flex items-start gap-2 text-white/60 font-roboto text-sm">
              <i class="pi pi-map-marker text-xs mt-0.5 shrink-0"></i>
              <span>Colombia</span>
            </li>
          </ul>
        </div>
      </div>

      <div
        class="max-w-[1300px] mx-auto pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p class="font-roboto text-white/40 text-sm">&copy; 2026 Convivia. Todos los derechos reservados.</p>
        <div class="flex items-center gap-6">
          <a
            routerLink="/legal/terminos"
            class="text-white/40 no-underline font-roboto text-sm transition-colors duration-200 hover:text-white"
            >Términos y Condiciones</a
          >
          <a
            routerLink="/legal/privacidad"
            class="text-white/40 no-underline font-roboto text-sm transition-colors duration-200 hover:text-white"
            >Política de Privacidad</a
          >
          <button
            type="button"
            (click)="cookieConsent.openPreferences()"
            class="text-white/40 bg-transparent border-none p-0 cursor-pointer font-roboto text-sm transition-colors duration-200 hover:text-white">
            Preferencias de cookies
          </button>
        </div>
      </div>
    </footer>
  }
  @default {
    <div class="h-16 flex items-center justify-between">
      <p class="text-sm text-teal-950 dark:text-surface-0 font-semibold font-montserrat">SOCH CONVIVIA</p>
      <div class="flex items-center gap-6">
        <a
          href="/legal/terminos"
          class="text-sm text-teal-950/50 dark:text-surface-0/50 no-underline font-roboto transition-colors duration-200 hover:text-teal-950 dark:hover:text-surface-0"
          >Términos y Condiciones</a
        >
        <a
          href="/legal/privacidad"
          class="text-sm text-teal-950/50 dark:text-surface-0/50 no-underline font-roboto transition-colors duration-200 hover:text-teal-950 dark:hover:text-surface-0"
          >Política de Privacidad</a
        >
        <button
          type="button"
          (click)="cookieConsent.openPreferences()"
          class="text-sm text-teal-950/50 dark:text-surface-0/50 bg-transparent border-none p-0 cursor-pointer font-roboto transition-colors duration-200 hover:text-teal-950 dark:hover:text-surface-0">
          Preferencias de cookies
        </button>
      </div>
    </div>
  }
}
